// For useMediaQuery (react-responsive format)
// export const BREAKPOINTS_REACT_RESPONSIVE = {
//   mobile: { maxWidth: 400 },
//   tablet: { minWidth: 401, maxWidth: 768 },
//   desktop: { minWidth: 769 },
// } as const;

// Numeric breakpoints
export const BREAKPOINT_VALUES = {
  mobile_max: 699,
  tablet_min: 700,
  tablet_max: 884,
  desktop_min: 885,
  desktop_max: 1280,
  largeDesktop_max: 1920,
} as const;